import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs';
import { TipoCliente } from '../models/tipoCliente';
import { Vendedor } from '../models/vendedor';
import { TipoCambio } from '../models/tipoCambio';
import { TerminoPago } from '../models/terminoPago';
import { TipoListaPrecio } from '../models/tipoListaPrecio';
import { Producto } from '../models/producto';
import { GrupoCliente } from '../models/grupoCliente';
import { ListaPrecioCabecera } from '../models/listaPrecioCabecera';
import { ListaPrecioItem } from '../models/listaPrecioItem';
import { Region } from '../models/region';
import { Deposito } from '../models/deposito';
import { UbicacionAlmacenamiento } from '../models/ubicacionAlmacenamiento';
import { ZonaVendedor } from '../models/zonaVendedor';
import { Distribuidor } from '../models/distribuidor';
import { Division } from '../models/division';
import { Campania } from '../models/campania';
import { Numerador } from '../models/numerador';
import { AutorizacionDtoDisc } from '../models/autorizacionDtoDisc';
import { AutorizacionNC } from '../models/autorizacionNC';
import { TipoListaPrecioTerminoPago } from '../models/tipoListaPrecioTerminoPago';
import { TipoListaPrecioGrupoCliente } from '../models/tipoListaPrecioGrupoCliente';
import { MotivoDevolucionNC } from '../models/motivoDevolucionNC';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';
import { ShipToDistribuidor } from '../models/shipToDistribuidor';


@Injectable({
  providedIn: 'root'
})

export class TablasService {

  private tablasServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(private configService: ConfigService, private dialog: MatDialog, private httpCliente: HttpClient,
    private tokenService: TokenService
  ) {
    this.tablasServerUri = this.apiUrl + '/' + this.configService.TablasURI;
  }
  
  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  cPayconds(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CPayconds?idPais=' + idPais, { headers: this.getHeaders() });
  }

  cUsuariosVendedoresAutocomplete(search: string, userName: string, adm: boolean, idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CUsuariosVendedoresAutocomplete?search=' + search + '&userName=' + userName + '&adm=' + adm + '&idPais=' + idPais, { headers: this.getHeaders() });
  }

  cTaxes(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTaxes?idPais=' + idPais, { headers: this.getHeaders() });
  }
  cProcesos(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CProcesos?idPais=' + idPais, { headers: this.getHeaders() });
  }

  cClientes(idPais: string, idDivision: string, userName: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CClientes?idPais=' + idPais + '&idDivision=' + idDivision + '&userName=' + userName, { headers: this.getHeaders() });
  }

  cTiposClientes(idPais: string, idDivision: string, userName: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTiposClientes?idPais=' + idPais + '&idDivision=' + idDivision + '&userName=' + userName, { headers: this.getHeaders() });
  }
  cVendedores(idPais: string, idDivision: string, idRegion: string, userName: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CVendedores?idPais=' + idPais + '&idDivision=' + idDivision + '&idRegion=' + idRegion + '&userName=' + userName, { headers: this.getHeaders() });
  }

  cTipoClienteDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'cTipoClienteDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aTipoCliente(model: TipoCliente) {
    return this.httpCliente.post(this.tablasServerUri + 'ATipoCliente', model, { headers: this.getHeaders() });
  }
  mTipoCliente(model: TipoCliente) {
    return this.httpCliente.post(this.tablasServerUri + 'MTipoCliente', model, { headers: this.getHeaders() });
  }

  bTipoCliente(model: TipoCliente) {
    return this.httpCliente.delete(this.tablasServerUri + 'BTipoCliente?codigo=' + model.codigo, { headers: this.getHeaders() });
  }

  bTerminoPago(model: TerminoPago) {
    return this.httpCliente.delete(this.tablasServerUri + 'BTerminoPago?codigo=' + model.codigo, { headers: this.getHeaders() });
  }

  aTerminoPago(model: TerminoPago) {
    return this.httpCliente.post(this.tablasServerUri + 'ATerminoPago', model, { headers: this.getHeaders() });
  }
  mTerminoPago(model: TerminoPago) {
    return this.httpCliente.post(this.tablasServerUri + 'MTerminoPago', model, { headers: this.getHeaders() });
  }

  cTerminosPago(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTerminosPago?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  cFormasPago() {
    return this.httpCliente.get(this.tablasServerUri + 'CFormasPago', { headers: this.getHeaders() });
  }

  cTerminoPagoDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CTerminoPagoDB?codigo=' + codigo, { headers: this.getHeaders() });
  }

  cTipoListaPrecioDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CTipoListaPrecioDB?codigo=' + codigo, { headers: this.getHeaders() });
  }

  cTiposListasPrecios(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTiposListasPrecios?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  aTipoListaPrecio(model: TipoListaPrecio) {
    return this.httpCliente.post(this.tablasServerUri + 'ATipoListaPrecio', model, { headers: this.getHeaders() });
  }
  mTipoListaPrecio(model: TipoListaPrecio) {
    return this.httpCliente.post(this.tablasServerUri + 'MTipoListaPrecio', model, { headers: this.getHeaders() });
  }

  cTiposCambio(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTiposCambio?idPais=' + idPais, { headers: this.getHeaders() });
  }
  cTipoCambioDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CTipoCambioDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aTipoCambio(model: TipoCambio) {
    return this.httpCliente.post(this.tablasServerUri + 'ATipoCambio', model, { headers: this.getHeaders() });
  }
  mTipoCambio(model: TipoCambio) {
    return this.httpCliente.post(this.tablasServerUri + 'MTipoCambio', model, { headers: this.getHeaders() });
  }
  cMonedas(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CMonedas?idPais=' + idPais, { headers: this.getHeaders() });
  }
  cGruposClientes(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CGruposClientes?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cGrupoClienteDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CGrupoClienteDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aGrupoCliente(model: GrupoCliente) {
    return this.httpCliente.post(this.tablasServerUri + 'AGrupoCliente', model, { headers: this.getHeaders() });
  }
  mGrupoCliente(model: GrupoCliente) {
    return this.httpCliente.post(this.tablasServerUri + 'MGrupoCliente', model, { headers: this.getHeaders() });
  }

  bRegion(model: Region) {
    return this.httpCliente.delete(this.tablasServerUri + 'BRegion?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cRegionDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CRegionDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aRegion(model: Region) {
    return this.httpCliente.post(this.tablasServerUri + 'ARegion', model, { headers: this.getHeaders() });
  }
  mRegion(model: Region) {
    return this.httpCliente.post(this.tablasServerUri + 'MRegion', model, { headers: this.getHeaders() });
  }

  cDepositos(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CDepositos?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  bDeposito(model: Deposito) {
    return this.httpCliente.delete(this.tablasServerUri + 'BDeposito?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cDepositoDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CDepositoDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aDeposito(model: Deposito) {
    return this.httpCliente.post(this.tablasServerUri + 'ADeposito', model, { headers: this.getHeaders() });
  }
  mDeposito(model: Deposito) {
    return this.httpCliente.post(this.tablasServerUri + 'MDeposito', model, { headers: this.getHeaders() });
  }
  cCuentasparaDepositosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, search: string) {

    return this.httpCliente.get(this.tablasServerUri + 'CCuentasparaDepositosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&search=" + search, { headers: this.getHeaders() });
  }
  cUbicacionesAlmacenamientos(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CUbicacionesAlmacenamientos?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  bUbicacionAlmacenamiento(model: UbicacionAlmacenamiento) {
    return this.httpCliente.delete(this.tablasServerUri + 'BUbicacionAlmacenamiento?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cUbicacionAlmacenamientoDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CUbicacionAlmacenamientoDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aUbicacionAlmacenamiento(model: UbicacionAlmacenamiento) {
    return this.httpCliente.post(this.tablasServerUri + 'AUbicacionAlmacenamiento', model, { headers: this.getHeaders() });
  }
  mUbicacionAlmacenamiento(model: UbicacionAlmacenamiento) {
    return this.httpCliente.post(this.tablasServerUri + 'MUbicacionAlmacenamiento', model, { headers: this.getHeaders() });
  }
  cPlantas(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CPlantas?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cZonasVendedores(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CZonasVendedores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cZonaVendedorDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CZonaVendedorDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aZonaVendedor(model: ZonaVendedor) {
    return this.httpCliente.post(this.tablasServerUri + 'AZonaVendedor', model, { headers: this.getHeaders() });
  }
  mZonaVendedor(model: ZonaVendedor) {
    return this.httpCliente.post(this.tablasServerUri + 'MZonaVendedor', model, { headers: this.getHeaders() });
  }
  cDistribuidores(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CDistribuidores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cDistribuidorDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CDistribuidorDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aDistribuidor(model: Distribuidor) {
    return this.httpCliente.post(this.tablasServerUri + 'ADistribuidor', model, { headers: this.getHeaders() });
  }
  mDistribuidor(model: Distribuidor) {
    return this.httpCliente.post(this.tablasServerUri + 'MDistribuidor', model, { headers: this.getHeaders() });
  }
  cDivisiones(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CDivisiones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cDivisionDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CDivisionDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aDivision(model: Division) {
    return this.httpCliente.post(this.tablasServerUri + 'ADivision', model, { headers: this.getHeaders() });
  }
  mDivision(model: Division) {
    return this.httpCliente.post(this.tablasServerUri + 'MDivision', model, { headers: this.getHeaders() });
  }
  cCampanias(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CCampanias?idPais=' + idPais, { headers: this.getHeaders() });
  }
  cCampaniaDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CCampaniaDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  mCampania(model: Campania) {
    return this.httpCliente.post(this.tablasServerUri + 'MCampania', model, { headers: this.getHeaders() });
  }
  cNumeradores(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CNumeradores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cNumeradorDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CNumeradorDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  mNumerador(model: Numerador) {
    return this.httpCliente.post(this.tablasServerUri + 'MNumerador', model, { headers: this.getHeaders() });
  }
  cAutorizacionesDtoDisc(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CAutorizacionesDtoDisc?idPais=' + idPais, { headers: this.getHeaders() });
  }
  CAutorizacionDtoDiscDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CAutorizacionDtoDiscDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  mAutorizacionDtoDisc(model: AutorizacionDtoDisc) {
    return this.httpCliente.post(this.tablasServerUri + 'MAutorizacionDtoDisc', model, { headers: this.getHeaders() });
  }
  bAutorizacionDtoDisc(model: AutorizacionDtoDisc) {
    return this.httpCliente.delete(this.tablasServerUri + 'BAutorizacionDtoDisc?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  aAutorizacionDtoDisc(model: AutorizacionDtoDisc) {
    return this.httpCliente.post(this.tablasServerUri + 'AAutorizacionDtoDisc', model, { headers: this.getHeaders() });
  }
  aAutorizacionNC(model: AutorizacionNC) {
    return this.httpCliente.post(this.tablasServerUri + 'AAutorizacionNC', model, { headers: this.getHeaders() });
  }
  cAutorizacionesNC(idPais: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CAutorizacionesNC?idPais=' + idPais, { headers: this.getHeaders() });
  }
  cAutorizacionNCDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CAutorizacionNCDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  mAutorizacionNC(model: AutorizacionNC) {
    return this.httpCliente.post(this.tablasServerUri + 'MAutorizacionNC', model, { headers: this.getHeaders() });
  }
  bAutorizacionNC(model: AutorizacionNC) {
    return this.httpCliente.delete(this.tablasServerUri + 'BAutorizacionNC?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cTiposListasPreciosPorTerminoPago(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTiposListasPreciosPorTerminoPago?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  bTipoListasPreciosPorTerminoPago(model: TipoListaPrecioTerminoPago) {
    return this.httpCliente.delete(this.tablasServerUri + 'BTipoListasPreciosPorTerminoPago?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cTipoLPPorTerminoPagoDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CTipoLPPorTerminoPagoDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aTipoListaPrecioTerminoPago(model: TipoListaPrecioTerminoPago) {
    return this.httpCliente.post(this.tablasServerUri + 'ATipoListaPrecioTerminoPago', model, { headers: this.getHeaders() });
  }
  mTipoListaPrecioTerminoPago(model: TipoListaPrecioTerminoPago) {
    return this.httpCliente.post(this.tablasServerUri + 'MTipoListaPrecioTerminoPago', model, { headers: this.getHeaders() });
  }
  cTiposListasPreciosPorGrupoCliente(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CTiposListasPreciosPorGrupoCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  bTipoListasPreciosPorGrupoCliente(model: TipoListaPrecioGrupoCliente) {
    return this.httpCliente.delete(this.tablasServerUri + 'BTipoListasPreciosPorGrupoCliente?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cTipoLPPorGrupoClienteDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CTipoLPPorGrupoClienteDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aTipoListaPrecioGrupoCliente(model: TipoListaPrecioGrupoCliente) {
    return this.httpCliente.post(this.tablasServerUri + 'ATipoListaPrecioGrupoCliente', model, { headers: this.getHeaders() });
  }
  mTipoListaPrecioGrupoCliente(model: TipoListaPrecioGrupoCliente) {
    return this.httpCliente.post(this.tablasServerUri + 'MTipoListaPrecioGrupoCliente', model, { headers: this.getHeaders() });
  }
  cMotivosDevolucionNC(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CMotivosDevolucionNC?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  bMotivoDevolucionNC(model: MotivoDevolucionNC) {
    return this.httpCliente.delete(this.tablasServerUri + 'BMotivoDevolucionNC?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
  cMotivoDevolucionNCDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CMotivoDevolucionNCDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aMotivoDevolucionNC(model: MotivoDevolucionNC) {
    return this.httpCliente.post(this.tablasServerUri + 'AMotivoDevolucionNC', model, { headers: this.getHeaders() });
  }
  mMotivoDevolucionNC(model: MotivoDevolucionNC) {
    return this.httpCliente.post(this.tablasServerUri + 'MMotivoDevolucionNC', model, { headers: this.getHeaders() });
  }

  cShipToDistribuidores(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tablasServerUri + 'CShipToDistribuidores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cShipToDistribuidorDB(codigo: number) {
    return this.httpCliente.get(this.tablasServerUri + 'CShipToDistribuidorDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  aShipToDistribuidor(model: ShipToDistribuidor) {
    return this.httpCliente.post(this.tablasServerUri + 'AShipToDistribuidor', model, { headers: this.getHeaders() });
  }
  mShipToDistribuidor(model: ShipToDistribuidor) {
    return this.httpCliente.post(this.tablasServerUri + 'MShipToDistribuidor', model, { headers: this.getHeaders() });
  }
    bShipToDistribuidor(model: ShipToDistribuidor) {
    return this.httpCliente.delete(this.tablasServerUri + 'BShipToDistribuidor?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
}
